"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconButton = void 0;
const styles_1 = require("@mui/material/styles");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
exports.StyledIconButton = (0, styles_1.styled)(IconButton_1.default)({
    padding: 0,
});
